import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DrugList,
  OtherFormularyInformation,
} from '@cigna/pdl-viewer/drug-search/data-access';
import { AsyncData } from '@cigna/shared/angular/core/interfaces-util';

@Component({
  selector: 'cigna-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
})
export class SearchBoxComponent implements OnInit {
  @Output() getDrugList = new EventEmitter<string>();
  @Output() callToTypeaHead = new EventEmitter<string>();
  @Output() reset = new EventEmitter<boolean>();
  @Input() typeaHead: AsyncData<DrugList[]>;
  @Input() otherInfo: OtherFormularyInformation;
  @Input() consumerId: string;
  searchedDrugName: string;
  isFocusOnSearchDropdown: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  showSearchDropdown = false;
  planCode: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  emptyDrugStr: boolean;

  ngOnInit(): void {
    this.otherInfo = {};
    this.searchedDrugName = '';
  }

  focusOnOff(boolVal: boolean) {
    this.isFocusOnSearchDropdown = boolVal;
  }

  selectDrug(drugName: string) {
    if (drugName.length === 0) {
      this.emptyDrugStr = true;
      this.reset.emit(true);
      return;
    }
    this.emptyDrugStr = false;
    this.searchedDrugName = drugName;
    this.showSearchDropdown = false;
    this.isFocusOnSearchDropdown = false;
    this.focusOnOff(false);
    this.getDrugList.emit(drugName);
    this.searchedDrugName = '';
  }

  drugsListClick(drugName: string) {
    this.emptyDrugStr = false;
    this.searchedDrugName = '';
    this.getDrugList.emit(drugName);
  }

  resetBtnClick() {
    this.emptyDrugStr = false;
    this.searchedDrugName = '';
    this.otherInfo = {};
    this.reset.emit(true);
  }

  getTypeaHead(searchStr: string) {
    this.showSearchDropdown = searchStr.length > 0;
    if (searchStr.length > 0) {
      this.callToTypeaHead.emit(searchStr);
    }
  }

  searchDropdownFocusOut() {
    if (!this.isFocusOnSearchDropdown) {
      this.showSearchDropdown = false;
      this.emptyDrugStr = false;
    }
  }
}
